import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import './App.css';

function WebDevelopment() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];

  const services = [
    {
      title: t.webDevServiceDesign,
      description: t.webDevServiceDesignDesc,
      icon: '🎨'
    },
    {
      title: t.webDevServiceDevelopment,
      description: t.webDevServiceDevelopmentDesc,
      icon: '💻'
    },
    {
      title: t.webDevServiceEcommerce,
      description: t.webDevServiceEcommerceDesc,
      icon: '🛒'
    },
    {
      title: t.webDevServiceMaintenance,
      description: t.webDevServiceMaintenanceDesc,
      icon: '🔧'
    },
    {
      title: t.webDevServiceIntegration,
      description: t.webDevServiceIntegrationDesc,
      icon: '🔗'
    }
  ];

  const techStack = [
    {
      name: t.webDevTechReact,
      description: t.webDevTechReactDesc,
    },
    {
      name: t.webDevTechNode,
      description: t.webDevTechNodeDesc,
    },
    {
      name: t.webDevTechCloud,
      description: t.webDevTechCloudDesc,
    },
    {
      name: t.webDevTechAPI,
      description: t.webDevTechAPIDesc,
    },
    {
      name: t.webDevTechSecurity,
      description: t.webDevTechSecurityDesc,
    },
    {
      name: t.webDevTechPerformance,
      description: t.webDevTechPerformanceDesc,
    },
  ];

  const process = [
    {
      title: t.webDevProcess1,
      detail: t.webDevProcess1Desc
    },
    {
      title: t.webDevProcess2,
      detail: t.webDevProcess2Desc
    },
    {
      title: t.webDevProcess3,
      detail: t.webDevProcess3Desc
    },
    {
      title: t.webDevProcess4,
      detail: t.webDevProcess4Desc
    },
    {
      title: t.webDevProcess5,
      detail: t.webDevProcess5Desc
    }
  ];

  return (
    <div className="page">
      <header className="topbar">
        <Link to="/" className="brand">
          <img src="/velyntor_logo-removebg-preview.png" alt="Velyntor" className="brand-logo" />
        </Link>
        <div className="brand-center">VELYNTOR</div>
        <button
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          aria-label="Öppna meny"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="topbar-right">
          <nav className={`nav ${menuOpen ? 'open' : ''}`}>
            <Link to="/" onClick={() => setMenuOpen(false)}>
              {t.automation}
            </Link>
            <Link to="/marknadsforing" onClick={() => setMenuOpen(false)}>
              {t.marketing}
            </Link>
            <Link to="/webbutveckling" onClick={() => setMenuOpen(false)}>
              {t.webDevelopment}
            </Link>
            <Link to="/om-oss" onClick={() => setMenuOpen(false)}>
              {t.about}
            </Link>
            <Link to="/kontakt" onClick={() => setMenuOpen(false)}>
              {t.contact}
            </Link>
            <Link to="/kontakt" className="ghost-btn mobile-only" onClick={() => setMenuOpen(false)}>
              {t.bookMeeting}
            </Link>
            <button className="language-toggle mobile-only" onClick={toggleLanguage}>
              <img 
                src="https://flagcdn.com/w20/se.png" 
                alt="Svenska" 
                className={`flag-icon ${language === 'sv' ? 'active' : ''}`}
              />
              <span>/</span>
              <img 
                src="https://flagcdn.com/w20/gb.png" 
                alt="English" 
                className={`flag-icon ${language === 'en' ? 'active' : ''}`}
              />
            </button>
          </nav>
          <button className="language-toggle desktop-only" onClick={toggleLanguage}>
            <img 
              src="https://flagcdn.com/w20/se.png" 
              alt="Svenska" 
              className={`flag-icon ${language === 'sv' ? 'active' : ''}`}
            />
            <span>/</span>
            <img 
              src="https://flagcdn.com/w20/gb.png" 
              alt="English" 
              className={`flag-icon ${language === 'en' ? 'active' : ''}`}
            />
          </button>
        </div>
      </header>

      <main>
        <section className="hero webdev-hero">
          <div className="hero-text">
            <p className="eyebrow">{t.webDevEyebrow}</p>
            <h1>{t.webDevTitle}</h1>
            <p className="lede">
              {t.webDevText1}
            </p>
            <p className="lede">
              {t.webDevText2}
            </p>
            <div style={{ marginTop: '24px' }}>
              <Link to="/kontakt" className="primary-btn">
                {t.bookMeeting}
              </Link>
            </div>
          </div>
          <div className="hero-card webdev-hero-card">
            <div className="card-title">{t.webDevTechStack}</div>
            <div className="webdev-tech-grid">
              {techStack.map((tech, index) => (
                <div key={index} className="webdev-tech-item">
                  <div className="webdev-tech-dot"></div>
                  <div className="webdev-tech-text">
                    <div className="webdev-tech-name">{tech.name}</div>
                    <div className="webdev-tech-desc">{tech.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section services webdev-services">
          <div className="section-heading">
            <p className="eyebrow">{t.webDevServices}</p>
            <h2>{t.webDevServicesTitle}</h2>
            <p className="section-sub">
              {t.webDevServicesText1}
            </p>
          </div>
          <div className="grid">
            {services.map((service) => (
              <div key={service.title} className="card">
                <div className="card-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section alt platform-section webdev-platform">
          <div className="section-heading">
            <p className="eyebrow">{t.webDevTech}</p>
            <h2>{t.webDevTechTitle}</h2>
            <p className="section-sub">
              {t.webDevTechText1}
            </p>
            <p className="section-sub" style={{ marginTop: '16px' }}>
              {t.webDevTechText2}
            </p>
          </div>
          <div className="pill-row">
            {techStack.map((tech, index) => (
              <span key={index} className="pill">{tech.name}</span>
            ))}
          </div>
        </section>

        <section className="section webdev-process">
          <div className="section-heading">
            <p className="eyebrow">{t.webDevApproach}</p>
            <h2>{t.webDevApproachTitle}</h2>
          </div>
          <div className="steps">
            {process.map((step) => (
              <div key={step.title} className="step">
                <div className="step-dot" />
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section id="contact" className="section cta">
          <div>
            <p className="eyebrow">{t.contact}</p>
            <h2>{t.webDevCtaTitle}</h2>
            <p className="section-sub">
              {t.webDevCtaSubtitle}
            </p>
          </div>
          <div className="cta-actions">
            <Link to="/kontakt" className="primary-btn" style={{ textDecoration: 'none', display: 'inline-block' }}>{t.bookMeeting}</Link>
            <a href="mailto:info@velyntor.se" className="secondary-btn" style={{ textDecoration: 'none', display: 'inline-block' }}>{t.email}</a>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>{t.footerContact}</h4>
            <p style={{ marginTop: '8px' }}>
              <a href="mailto:info@velyntor.se">{t.email}</a>
            </p>
            <p style={{ marginTop: '4px' }}>
              <a href="tel:+46700252952">+46 70 025 29 52</a>
            </p>
            <p style={{ marginTop: '4px' }}>
              <a href="https://linkedin.com/company/techblaze-ab/" target="_blank" rel="noreferrer">
                LinkedIn
              </a>
            </p>
          </div>
          <div className="footer-section">
            <h4>{t.footerPages}</h4>
            <div className="footer-links">
              <Link to="/">{t.automation}</Link>
              <Link to="/marknadsforing">{t.marketing}</Link>
              <Link to="/webbutveckling">{t.webDevelopment}</Link>
              <Link to="/om-oss">{t.about}</Link>
              <Link to="/kontakt">{t.contact}</Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div>© {new Date().getFullYear()} Velyntor. {t.footerRights}</div>
        </div>
      </footer>
    </div>
  );
}

export default WebDevelopment;
